var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShampoo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M17.762 13.12V8.821h4.477v4.3"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M22.231 13.12H17.77s-6.377 4.27-1.318 18.38h7.098c5.06-14.11-1.318-18.38-1.318-18.38ZM20.99 10.207a.985.985 0 0 1-.99.981.986.986 0 0 1-.99-.981M17.797 10.092h4.399"
}))));
export default SvgShampoo;